import AI from "../images/ai.png";
import Cloud from "../images/Cloud.png";
import Laision from "../images/liaison.png";
import IOT from "../images/IOT.png";
import Digital from "../images/digital.png";
import Access from "../images/access.png";
import { useTranslation } from "react-i18next";

export const Keys = () => {
  const { t } = useTranslation();
  return [
    {
      image: AI,
      title: t("AI-powered yield management"),
      text: t("key IA text"),
    },
    {
      image: Laision,
      title: t("Seamless multimodal integration"),
      text: t("key multimodal text"),
    },
    {
      image: Cloud,
      title: t("Interoperability with leading PMS"),
      text: t("key cloud text"),
    },
    {
      image: IOT,
      title: t("IoT-based monitoring"),
      text: t("key IOT text"),
    },
    {
      image: Access,
      title: t("Smart gate and access control"),
      text: t("key smartGate text"),
    },
    {
      image: Digital,
      title: t("Fully digital user experience"),
      text: t("key digital text"),
    },
  ];
};
